
export type Dictionary<T> = Record<string, T>

export enum UploadType {
  FullRoof = 'full_roof',
  SolarContract = 'solar_contract',
  InitialFundingRequest = 'initial_funding_request',
  FinalFundingRequest = 'final_funding_request',
  FullFundingRequest = 'full_funding_request',
  FullFundingDocsWithRoof = 'full_funding_docs_w_roof',
  Other = 'other',
  ChangeOrder = 'change_order',
  VendorAchForm = 'vendor_ach_form',
  LoanModificationForm = 'loan_modification_form'
}

const UPLOAD_DOC_TYPES = {
  full_roof: 'Full Roof Funding Docs',
  solar_contract: 'Contract Docs',
  initial_funding_request: 'Initial Funding Docs',
  final_funding_request: 'Final Funding Docs',
  full_funding_request: 'Full Funding Docs',
  full_funding_docs_w_roof: 'Full Funding with Roof Docs',
  other: 'Other Docs',
  change_order: 'Change Order Docs',
  vendor_ach_form: 'Vendor ACH Form Docs',
  loan_modification_form: 'Loan Modification Form Docs'
}

export const docTypeDescription = (type: UploadType): string => {
  return UPLOAD_DOC_TYPES[type] || '[unknown doc type]'
}

// TODO: this is deprecated in favor of migration to checklist items
export type RequiredDocConfig = {
  _id?: string // only used during UI configuration
  slot: string
  instructions: string
  agentWorkflowId?: string
  agentWorkflowEnabled?: boolean
  presubmitAgentWorkflowId?: string
}

export type InstallerStatus = {
  _id?: string
  status: string
  description?: string
  owner?: string
  sequence?: number
  uploadType?: UploadType
  deprecated?: boolean
  allowContractChanges?: boolean
  isClosed?: boolean
  requiredDocuments?: string[]
  aliases?: string[] // other statuses that should be treated as equivalent
  progress?: number
  bg?: string
  fundReleaseType?: string
}

export type IncentiveProduct = {
  loanTerm: number,
  incentivizedRate: string,
  nonIncentiveRate: string,
  estPaymentWithoutIncentives: string,
  estPriceWithIncentives: string,
  programSavings: string,
  incentiveHouseholdIncomeMaximum: number,
  prequalCopy?: string,
  loanDetailHTML?: string,
  loanTableHTML?: string,
}

export type Incentive = {
  id: string
  amountFinanced: string
  emailHTML: string
  estPriceWithIncentives: string
  estPriceWithoutIncentives: string
  financingPartner: string
  financingPartnerLogo: string  // url
  incentiveDescription: string
  incentivizedRate: string
  landingPageURL: string
  loanDetailHTML: string
  loanTableHTML: string
  loanFees: string
  nonIncentiveRate: string
  prequalCopy: string
  programSavings: string
  savingsHTML: string
  tenant: string
  termsUrl: string
  EEAstatus: string
  incentiveProducts: IncentiveProduct[]
}

export type AgreementSchema = {
  browser: Record<string, unknown>
  timestamp: Date
  agrees: boolean
}

export type FundReleaseRequest = {
  _id?: string
  type: string
  amount: number
  agreementSigned: AgreementSchema
  isEmailSent: boolean
  requestedAt: Date
  approvedFromIp?: string
}

export type PaystubSubType = 'weekly' | 'biWeekly' | 'monthly'
export type TaxReturnSubType = 'joint' | 'individual'
export type DocSubType = PaystubSubType | TaxReturnSubType

export type IncomeDocument = {
  docType: string
  documents: File[]
  docSubType?: DocSubType
}

export type YesNoEmpty = 'yes' | 'no' | '' | undefined
